import {
  FETCH_LABELS_SUCCESS,
  LabelsPayload,
  LabelsActionTypes,
} from "./types";

export interface LabelsState {
  labels: LabelsPayload;
  loading: boolean;
}

const initial: LabelsState = { labels: {}, loading: true };

export default function labelsReducer(
  state = initial,
  action: LabelsActionTypes
): LabelsState {
  if (action.type === FETCH_LABELS_SUCCESS) {
    return { labels: action.payload, loading: false };
  }
  return state;
}
